
// Avoid closure compiler nonsense
module.exports.makeMap = function makeMap(...keyValuePairs) {
  const result = {};
  for (let i = 0; i < keyValuePairs.length; i += 2) {
    result[keyValuePairs[i]] = keyValuePairs[i + 1];
  }
  return result;
};
